module.exports = __webpack_public_path__ + "img/DE01161.5a45236e.png";